// src/app/modules/Visitors/pages/components/AddThreatModal.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { X, AlertTriangle } from 'lucide-react';
import './AddThreatModal.scss';

export function AddThreatModal({ show, onHide, profileId, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    alert_type: 'suspicious_behavior',
    severity: 'medium',
    description: '',
  });

 
    const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setFormData({
        alert_type: 'suspicious_behavior',
        severity: 'medium',
        description: '',
      });
      setLoading(false);
    }
  }, [show]);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!isMountedRef.current) return;
    
    setLoading(true);

    try {
      await dispatch(actions.addData('threat_alert', {
        ...formData,
        organization_id: organizationId,
        // profile_id: profileId,
      }, profileId));
      
      if (isMountedRef.current) {
        setFormData({
          alert_type: 'suspicious_behavior',
          severity: 'medium',
          description: '',
        });
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error('Error creating threat alert:', error);
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }


  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="md"
      className="add-threat-modal"
    >
      <div className="threat-modal-content">
        <div className="modal-header-custom">
          <h3>Create Threat Alert</h3>
          <button className="btn-close-custom" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body-custom">
            <div className="threat-icon-wrapper">
              <div className="threat-icon">
                <AlertTriangle size={32} />
              </div>
            </div>

            <h4 className="text-center mb-3">Report Security Threat</h4>
            <p className="text-muted text-center mb-4">
              Create a threat alert for this visitor to notify security personnel.
            </p>

            <div className="form-group">
              <label>Alert Type</label>
              <select
                name="alert_type"
                className="form-control"
                value={formData.alert_type}
                onChange={handleChange}
              >
                <option value="suspicious_behavior">Suspicious Behavior</option>
                <option value="unauthorized_access">Unauthorized Access</option>
                <option value="aggressive_conduct">Aggressive Conduct</option>
                <option value="policy_violation">Policy Violation</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Severity Level</label>
              <select
                name="severity"
                className="form-control"
                value={formData.severity}
                onChange={handleChange}
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="critical">Critical</option>
              </select>
            </div>

            <div className="form-group">
              <label>Description *</label>
              <textarea
                name="description"
                className="form-control"
                rows="4"
                value={formData.description}
                onChange={handleChange}
                placeholder="Describe the threat or security concern..."
                required
              />
            </div>
          </div>

          <div className="modal-footer-custom">
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={onHide}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-threat" 
              disabled={loading || !formData.description}
            >
              {loading ? (
                <>
                  Creating...
                  <span className="spinner"></span>
                </>
              ) : (
                <>
                  <AlertTriangle size={16} />
                  Create Alert
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}